import {
  grupoQualificadoSchema,
  instanciaWahaSchema,
  resultadoTesteGrupoSchema,
  statusMonitoramentoGruposSchema,
  type GrupoQualificadoDto,
  type InstanciaWahaDto,
  type ResultadoTesteGrupoDto,
  type SalvarInstanciasDto,
  type SalvarListIdGruposDto,
  type SalvarWahaDto,
  type StatusMonitoramentoGruposDto,
  type TestarGrupoDto,
} from "@base/contracts";
import { z } from "zod";
import type { ClienteHttp } from "../../../shared/http/cliente-http";

const okSchema = z.object({ ok: z.literal(true) });
const instanciasListaSchema = z.array(instanciaWahaSchema);
const gruposListaSchema = z.array(grupoQualificadoSchema);

export type MonitoramentoGruposGateway = {
  obterStatus(): Promise<StatusMonitoramentoGruposDto>;
  salvarWaha(corpo: SalvarWahaDto): Promise<void>;
  salvarListId(corpo: SalvarListIdGruposDto): Promise<void>;
  listarInstancias(): Promise<readonly InstanciaWahaDto[]>;
  salvarInstancias(corpo: SalvarInstanciasDto): Promise<void>;
  listarGrupos(): Promise<readonly GrupoQualificadoDto[]>;
  testarGrupo(corpo: TestarGrupoDto): Promise<ResultadoTesteGrupoDto>;
};

export class MonitoramentoGruposGatewayHttp
  implements MonitoramentoGruposGateway
{
  constructor(private readonly http: ClienteHttp) {}

  obterStatus(): Promise<StatusMonitoramentoGruposDto> {
    return this.http.requisitar(
      "/v1/monitoramento-grupos/status",
      statusMonitoramentoGruposSchema,
    );
  }

  async salvarWaha(corpo: SalvarWahaDto): Promise<void> {
    await this.http.requisitar("/v1/monitoramento-grupos/waha", okSchema, {
      metodo: "PATCH",
      corpo,
    });
  }

  async salvarListId(corpo: SalvarListIdGruposDto): Promise<void> {
    await this.http.requisitar(
      "/v1/monitoramento-grupos/clickup-lista",
      okSchema,
      { metodo: "PATCH", corpo },
    );
  }

  listarInstancias(): Promise<readonly InstanciaWahaDto[]> {
    return this.http.requisitar(
      "/v1/monitoramento-grupos/instancias",
      instanciasListaSchema,
    );
  }

  async salvarInstancias(corpo: SalvarInstanciasDto): Promise<void> {
    await this.http.requisitar(
      "/v1/monitoramento-grupos/instancias",
      okSchema,
      { metodo: "PATCH", corpo },
    );
  }

  listarGrupos(): Promise<readonly GrupoQualificadoDto[]> {
    return this.http.requisitar(
      "/v1/monitoramento-grupos/grupos",
      gruposListaSchema,
    );
  }

  testarGrupo(corpo: TestarGrupoDto): Promise<ResultadoTesteGrupoDto> {
    return this.http.requisitar(
      "/v1/monitoramento-grupos/testar",
      resultadoTesteGrupoSchema,
      { metodo: "POST", corpo },
    );
  }
}
